import type { Document, DocumentFormValues } from '../../model';

export function formatDocumentToApiDocument<T extends string>(
  doc: DocumentFormValues,
  type: T
): Document & { type: T } {
  return { documentId: doc.documentId, type, fileName: doc.fileName };
}
